import PropTypes from 'prop-types';
import SVG from '@activebrands/core-web/components/SVG';

const CloseIcon = ({ $style = {}, color = 'currentColor', height = 'auto', width = '12px', ...rest }) => {
    const style = { width, height, ...$style };

    return (
        <SVG $style={style} fill="none" viewBox="0 0 12 12" {...rest}>
            <path d="M11 1 1 11M11 11 1 1" stroke={color} />
        </SVG>
    );
};

CloseIcon.propTypes = {
    $style: PropTypes.object,
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

export default CloseIcon;
